package util

import kotlinx.browser.document
import org.w3c.dom.HTMLElement

object ScrollIndicator {
    private var handled = false

    fun handle(scrollProgress: Double) {
        if (handled) return

        if (scrollProgress > 0.1) {
            handled = true
            (document.querySelector(".scroll-hint") as? HTMLElement)?.let {
                println("FOUND IT")
                it.style.opacity = "0"
            } ?: run {
                println("NOT FOUND")
            }
        }
    }
}